import React, { useState, useEffect } from 'react';

const EmailPopup = ({ isOpen, onClose, data, onSend }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Reset email field and error when modal opens
  useEffect(() => {
    if (isOpen) {
      setEmail('');
      setError('');
      setLoading(false);
    }
  }, [isOpen]);

  const isValidEmail = (email) => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleSend = async () => {
    if (!isValidEmail(email)) {
      setError('Please enter a valid email address.');
      return;
    }

    setLoading(true);
    try {
      await onSend({ ...data, email });
      onClose();
    } catch (err) {
      setError('Failed to send email. Please try again.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
        <h2 className="text-xl font-semibold mb-4">Email Document</h2>

        <div className="mb-4 space-y-1">
          <p>
            <span className="font-medium">Patient Name:</span> {data.name}
          </p>
        </div>

        <p className="text-sm text-gray-500 mb-3">
          Email will be sent only if the patient has signed the form.
        </p>

        <input
          type="email"
          placeholder="Enter email"
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
            setError('');
          }}
          className="w-full px-3 py-2 border border-gray-300 rounded mb-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
        />

        {error && <p className="text-sm text-red-500 mb-2">{error}</p>}

        <div className="flex justify-end space-x-2">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-700 rounded hover:bg-gray-400"
            disabled={loading}
          >
            Close
          </button>
          <button
            onClick={handleSend}
            disabled={!email || loading}
            className={`px-4 py-2 rounded text-white ${
              !email || loading
                ? 'bg-blue-300 cursor-not-allowed'
                : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            {loading ? 'Sending...' : 'Send Email'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailPopup;
